import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GridContainer } from '../../global';
import {
    TopInfoContainer,
    FormContainer,
    CheckboxLabel,
    DisclaimerText,
    IntegratorButton,
    SubmitButton,
    FormRow,
    StyledLabel,
    StyledInput,
    ActionsContainer,
    SuccessContainer,
    SuccessActions,
    SuccessButton
} from './style';

function Cadastro() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        razao_social: "",
        l10n_br_cnpj_cpf: "",
        email: "",
        mobile: "",
        zip: "",
        term_accept: false,
    });

   const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
    }));
};

    const handleCnpjCpfChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 11) {
            value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        } else {
            value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }
        setFormData(prev => ({ ...prev, l10n_br_cnpj_cpf: value }));
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 10) {
            value = value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        } else {
            value = value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        }
        setFormData(prev => ({ ...prev, mobile: value }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!formData.term_accept) {
            setError("Você precisa aceitar os termos para continuar.");
            return;
        }

        setLoading(true);
        setError('');

        const payload = {
            ...formData,
            term_accept: 'Yes',
            csrf_token: '5bf80d8cf22e6c59ee8e4acb9954c2679fd7dfc7o1784737878'
        };

        try {
            const response = await fetch('https://gestao.renovera.com.br/website_form/res.partner', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                const errorMessage = errorData?.error?.message || `Erro ${response.status}: Ocorreu um problema ao enviar o cadastro.`;
                throw new Error(errorMessage);
            }

            setSuccess(true);

        } catch (err) {
            setError(err.message || "Não foi possível conectar à API. Tente novamente mais tarde.");
        } finally {
            setLoading(false);
        }
    };

    const whatsAppMessage = encodeURIComponent("Olá, acabei de fazer o cadastro, mas ainda não recebi o e-mail. Pode me ajudar?");
    const whatsAppLink = `https://wa.me/551151966625?text=${whatsAppMessage}`;

    return (
        <div style={{ padding: '60px 0', backgroundColor: '#f9f9f9' }}>
            <GridContainer>
                <TopInfoContainer>
                    <p>Já possui cadastro? Acesse a plataforma no botão abaixo.</p>
                    <IntegratorButton href="https://integrador.renovera.com.br/login" target="_blank">
                        ÁREA DO INTEGRADOR
                    </IntegratorButton>
                </TopInfoContainer>

                  <FormContainer>
                    {success ? (
                        <SuccessContainer>
                            <p>Muito obrigado por se cadastrar! Logo mais, receberá a senha no e-mail informado. Qualquer dúvida, entre em contato pelo WhatsApp.</p>
                            <SuccessActions>
                                <SuccessButton as="button" onClick={() => navigate('/')}>Voltar para Home</SuccessButton>
                                <SuccessButton href={whatsAppLink} target="_blank" rel="noopener noreferrer">WhatsApp</SuccessButton>
                            </SuccessActions>
                        </SuccessContainer>
                    ) : (
                        <form onSubmit={onSubmit}>
                            <FormRow>
                                <StyledLabel htmlFor="name">Nome Fantasia *</StyledLabel>
                                <StyledInput id="name" type="text" name="name" placeholder="Ex: Renovera" value={formData.name} onChange={handleChange} required />
                            </FormRow>
                            <FormRow>
                                <StyledLabel htmlFor="razao_social">Razão Social *</StyledLabel>
                                <StyledInput id="razao_social" type="text" name="razao_social" placeholder="Ex: Renovera LTDA" value={formData.razao_social} onChange={handleChange} />
                            </FormRow>
                            <FormRow>
                                <StyledLabel htmlFor="cnpj_cpf">CNPJ *</StyledLabel>
                                <StyledInput id="cnpj_cpf" type="text" maxLength={18} name="l10n_br_cnpj_cpf" placeholder="00.000.000/0000-00" value={formData.l10n_br_cnpj_cpf} onChange={handleCnpjCpfChange} required />
                            </FormRow>
                            <FormRow>
                                <StyledLabel htmlFor="email">E-mail *</StyledLabel>
                                <StyledInput id="email" type="email" name="email" placeholder="Ex: renovera@renovera.com.br" value={formData.email} onChange={handleChange} required />
                            </FormRow>
                            <FormRow>
                                <StyledLabel htmlFor="mobile">Celular com DDD *</StyledLabel>
                                <StyledInput id="mobile" type="text" maxLength={15} name="mobile" placeholder="(00) 00000-0000" value={formData.mobile} onChange={handlePhoneChange} required />
                            </FormRow>
                            <FormRow>
                                <StyledLabel htmlFor="zip">CEP *</StyledLabel>
                                <StyledInput id="zip" type="text" name="zip" maxLength={9} placeholder="Ex: 13780-000" value={formData.zip} onChange={handleChange} required />
                            </FormRow>

                            <ActionsContainer>
                                <CheckboxLabel>
                                    <input type="checkbox" name="term_accept" checked={formData.term_accept} onChange={handleChange} />
                                    Li e aceito os termos de serviço.
                                </CheckboxLabel>
                                <DisclaimerText>
                                    Ao clicar no botão, você permite que a Renovera armazene, processe e comunique com você por meio das informações pessoais enviadas acima. Você pode deixar essas comunicações quando quiser.
                                </DisclaimerText>

                                {error && <p style={{ color: 'red' }}>{error}</p>}

                                <SubmitButton type="submit" disabled={loading}>
                                    {loading ? "Enviando..." : "Cadastrar"}
                                </SubmitButton>
                            </ActionsContainer>
                        </form>
                    )}
                </FormContainer>
            </GridContainer>
        </div>
    );
}

export default Cadastro;